import { put, select, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import api from 'services/api';
import { truckersAPI } from 'services/apiRest';

import TruckersActions from '../ducks/trucker';

export function* getTruckers() {
  try {
    // Usar API REST ao invés de Firebase
    const truckers = yield call(truckersAPI.listar);

    yield put(TruckersActions.getTruckersSuccess(truckers));
  } catch (err) {
    console.error('Erro ao buscar truckers:', err);
    yield put(TruckersActions.getTruckersFailure(err));
  }
}

export function* getOneTrucker({ id }) {
  try {
    // Usar API REST ao invés de Firebase
    const trucker = yield call(truckersAPI.buscarPorId, id);

    yield put(TruckersActions.getOneTruckerSuccess(trucker));
  } catch (err) {
    console.error('Erro ao buscar trucker:', err);
    yield put(TruckersActions.getOneTruckerFailure(err));
  }
}

export function* getCpfTrucker({ cpf }) {
  try {
    // Usar API REST ao invés de Firebase
    const trucker = yield call(truckersAPI.buscarPorCpf, cpf);

    if (trucker) {
      yield put(TruckersActions.getOneTruckerSuccess(trucker));
    } else {
      yield put(TruckersActions.getOneTruckerFailure(new Error('Trucker não encontrado')));
    }
  } catch (err) {
    console.error('Erro ao buscar trucker por CPF:', err);
    yield put(TruckersActions.getOneTruckerFailure(err));
  }
}

export function* reportPending({ id, body, closeModal }) {
  try {
    yield api
      .firestore()
      .collection('reports')
      .add({
        body,
        created_at: new Date(),
        direction: id,
        title: 'Pendência no cadastro',
      })
      .then((ref) => ref.update({ id: ref.id }));

    yield put(TruckersActions.reportPendingSuccess());
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Pendência reportada',
      })
    );
    closeModal();
  } catch (err) {
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao reportar pendência',
      })
    );
    yield put(TruckersActions.reportPendingFailure(err));
  }
}

export function* updateAditionalDocument({
  values,
  url_document,
  id,
  modalClose,
}) {
  try {
    const user = yield api.firestore().collection('users').doc(id).get();

    const { documents } = user.data();
    const index = documents.findIndex(
      (item) => item.url_document === url_document
    );

    documents[index] = Object.assign(documents[index], values);

    yield api.firestore().collection('users').doc(id).update({ documents });

    yield put(TruckersActions.updateAditionalDocumentSuccess());
    yield put(TruckersActions.getOneTruckerRequest(id));

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Documento atualizado.',
      })
    );
    modalClose();
  } catch (err) {
    yield put(TruckersActions.updateAditionalDocumentFailure(err));
  }
}

export function* setDocumentData({ values, closeModal }) {
  try {
    const { oneTrucker } = yield select((state) => state.trucker);

    yield api
      .firestore()
      .collection('users')
      .doc(oneTrucker.id)
      .update({
        ...values,
        birth_date: new Date(values.birth_date),
        licenseDue: new Date(values.licenseDue),
        firstlicense: new Date(values.birth_date),
        date_risky: new Date(values.date_risky),
        updated_at: new Date(),
      });

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Aprovação realizada.',
      })
    );

    closeModal();

    yield put(TruckersActions.setDocumentDataSuccess());
  } catch (err) {
    yield put(TruckersActions.setDocumentDataFailure(err));
  }
}

// CRUD de Caminhoneiros
export function* addTrucker({ trucker, closeModal }) {
  try {
    const truckerCriado = yield call(truckersAPI.criar, trucker);
    yield put(TruckersActions.addTruckerSuccess(truckerCriado));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Caminhoneiro criado com sucesso',
      })
    );
    if (closeModal) closeModal();
    // Recarregar lista
    yield put(TruckersActions.getTruckersRequest());
  } catch (err) {
    yield put(TruckersActions.addTruckerFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao criar caminhoneiro',
        message: err.message,
      })
    );
  }
}

export function* updateTrucker({ id, trucker, closeModal }) {
  try {
    const truckerAtualizado = yield call(truckersAPI.atualizar, id, trucker);
    yield put(TruckersActions.updateTruckerSuccess(truckerAtualizado));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Caminhoneiro atualizado com sucesso',
      })
    );
    if (closeModal) closeModal();
    // Recarregar lista
    yield put(TruckersActions.getTruckersRequest());
  } catch (err) {
    yield put(TruckersActions.updateTruckerFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao atualizar caminhoneiro',
        message: err.message,
      })
    );
  }
}

export function* removeTrucker({ id }) {
  try {
    yield call(truckersAPI.deletar, id);
    yield put(TruckersActions.removeTruckerSuccess(id));
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Caminhoneiro removido com sucesso',
      })
    );
  } catch (err) {
    yield put(TruckersActions.removeTruckerFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao remover caminhoneiro',
        message: err.message,
      })
    );
  }
}
